// This is a comment to force a linter refresh.
import {
  FETCH_SITE_EVENT_COUNTS_REQUEST,
  FETCH_SITE_EVENT_COUNTS_SUCCESS,
  FETCH_SITE_EVENT_COUNTS_FAILURE,
  FETCH_SITE_EVENT_DRILLABLE_COUNTS_REQUEST,
  FETCH_SITE_EVENT_DRILLABLE_COUNTS_SUCCESS,
  FETCH_SITE_EVENT_DRILLABLE_COUNTS_FAILURE,
} from './types';

const initialState = {
  eventCounts: {
    loading: false,
    data: [],
    error: null,
  },
  drillableEventCounts: {
    loading: false,
    data: [],
    error: null,
  },
};

export default function eventsReducer(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_SITE_EVENT_COUNTS_REQUEST:
      return {
        ...state,
        eventCounts: {
          ...state.eventCounts,
          loading: true,
          error: null,
        },
      };
    case FETCH_SITE_EVENT_COUNTS_SUCCESS:
      return {
        ...state,
        eventCounts: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case FETCH_SITE_EVENT_COUNTS_FAILURE:
      return {
        ...state,
        eventCounts: {
          ...state.eventCounts,
          loading: false,
          error: action.payload,
        },
      };
    case FETCH_SITE_EVENT_DRILLABLE_COUNTS_REQUEST:
      return {
        ...state,
        drillableEventCounts: {
          ...state.drillableEventCounts,
          loading: true,
          error: null,
        },
      };
    case FETCH_SITE_EVENT_DRILLABLE_COUNTS_SUCCESS:
      return {
        ...state,
        drillableEventCounts: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case FETCH_SITE_EVENT_DRILLABLE_COUNTS_FAILURE:
      return {
        ...state,
        drillableEventCounts: {
          ...state.drillableEventCounts,
          loading: false,
          error: action.payload,
        },
      };
    default:
      return state;
  }
}
